/**
 * Shared cost-formatting helpers for the AI Costs page and its sub-components.
 *
 * The backend SUM()::bigint / numeric columns arrive from node-pg as STRINGS,
 * so every arithmetic or formatting read must pass through `num` first (it also
 * guards undefined → NaN → 0).
 */

/** Coerce a cost/token aggregate (possibly a node-pg string) to a finite number. */
export function num(v: number | string | null | undefined): number {
  const n = typeof v === 'string' ? parseFloat(v) : v;
  return typeof n === 'number' && Number.isFinite(n) ? n : 0;
}

/** Format a dollar amount, with sub-cent precision for tiny values. */
export function formatCost(value: number | string | null | undefined): string {
  const n = typeof value === 'string' ? parseFloat(value) : value;
  if (n === null || n === undefined || Number.isNaN(n)) return '—';
  if (n === 0) return '$0.00';
  if (n < 0.01) return `$${n.toFixed(4)}`;
  if (n < 1000) return `$${n.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
  return `$${n.toLocaleString(undefined, { maximumFractionDigits: 0 })}`;
}

/** Display label for a provider code. */
export function providerLabel(provider: string): string {
  const p = provider.toLowerCase();
  if (p === 'xai') return 'xAI';
  if (p === 'anthropic') return 'Anthropic';
  return provider;
}
